import { AppThunk } from '@store/index';
import { sliceActions } from '@store/location/location.slice';
import { locationApi } from 'src/apis/index';

export const getLocations = (): AppThunk => (dispatch) => {
  locationApi.getLocation().then(({ data }) => {
    dispatch(sliceActions.getLocations(data));
  });
};

export const self = sliceActions;
